import { Actions, reducer } from './reducer';

import {
	createContext,
	PropsWithChildren,
	ReactNode,
	useContext,
	useReducer,
} from 'react';
import {
	ConsultaExamen,
	ConsultaExamenesPrams,
	ExamenesLabState,
} from 'utils/interfaces';
import { API } from 'utils';

export const ExamenesLabInitialState: ExamenesLabState = {
	view: 'form',
	resultados: [],
	consultaExamenes: [],
	showResultadoModal: false,
	showConsultaTuMedicoModal: false,
	nombrePaciente: '',
	sort: 'desc',
	sortResultados: true,
	page: 0,
	perPage: 5,
	totalPages: 0,
	resultsInPage: [],
};

interface ContextState extends ExamenesLabState {
	dispatch: React.Dispatch<Actions>;
	onFormSubmit: (params: ConsultaExamenesPrams) => void;
	resetState: () => void;
	getResultados: (consulta: ConsultaExamen) => void;
	setPage: (page: number) => void;
}

const ExamenesLabContext = createContext({} as ContextState);

export function ExamenesLabProvider({
	children,
}: PropsWithChildren<ReactNode>) {
	const [state, dispatch] = useReducer(reducer, ExamenesLabInitialState);

	const resetState = () => dispatch({ type: 'resetState' });

	const onFormSubmit = async (params: ConsultaExamenesPrams) => {
		try {
			const { data } = (await API.consultaExamenes(params)) as {
				data: {
					success: boolean;
					message: string;
					nombrePaciente: string;
					citas: ConsultaExamen[];
				};
			};
			if (data.success && data.message === '0') {
				dispatch({
					type: 'setConsultasExamenes',
					payload: {
						examenes: data.citas,
						nombrePaciente: data.nombrePaciente,
					},
				});
			} else {
				dispatch({
					type: 'setStatusMessage',
					payload: `el${data.message}`,
				});
			}
		} catch (error) {
			console.error(error);
		}
	};

	const getResultados = async (consulta: ConsultaExamen) => {
		const { id, medico } = consulta;
		try {
			const { data } = await API.resultadosExamenes(id);
			dispatch({
				type: 'setResultados',
				payload: { resultados: data, medico },
			});
		} catch (error) {
			console.error(error);
		}
	};

	const setPage = (page: number) => {
		dispatch({ type: 'setPage', payload: page });
	};

	const value = {
		...state,
		dispatch,
		onFormSubmit,
		resetState,
		getResultados,
		setPage,
	};

	return (
		<ExamenesLabContext.Provider value={value}>
			{children}
		</ExamenesLabContext.Provider>
	);
}

export function useExamenesLabCtx() {
	return useContext(ExamenesLabContext);
}
